import { render, staticRenderFns } from "./InputSplitContainer.vue?vue&type=template&id=5cbe8be2"
import script from "./InputSplitContainer.vue?vue&type=script&lang=js"
export * from "./InputSplitContainer.vue?vue&type=script&lang=js"
import style0 from "./InputSplitContainer.vue?vue&type=style&index=0&id=5cbe8be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports